module.exports = __webpack_public_path__ + "static/media/seven-dices.ce128f68.jpg";